import { render, staticRenderFns } from "./PreviousCashflowView.vue?vue&type=template&id=67252dff&scoped=true&"
import script from "./PreviousCashflowView.vue?vue&type=script&lang=js&"
export * from "./PreviousCashflowView.vue?vue&type=script&lang=js&"
import style0 from "./PreviousCashflowView.vue?vue&type=style&index=0&id=67252dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67252dff",
  null
  
)

export default component.exports